const trapFocus = ({
  element,
  action,
  shadowDomContext
}) => {
  const container = shadowDomContext || element;
  const escapeEvent = (event) => {
    if (event.key === "Escape") {
      action(event);
    }
  };
  const keyEvent = (event) => {
    if (event.key === "Tab") {
      const hasElement = event.composedPath().some((path) => path === container);
      if (!hasElement) {
        const firstElement = container?.querySelector(
          "button, a"
        );
        if (firstElement) {
          firstElement.focus();
        }
      }
    }
  };
  window.addEventListener("keydown", escapeEvent);
  window.addEventListener("keyup", keyEvent);
  return () => {
    window.removeEventListener("keydown", escapeEvent);
    window.removeEventListener("keyup", keyEvent);
  };
};
export {
  trapFocus
};
//# sourceMappingURL=trapFocus.js.map
